// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__n0JLv","box":"WorkspacesBox_box__2RF4j","node":"WorkspacesBox_node__34a8r"};